import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react/index';

import './readonlycontent.scss';

@observer
export class ReadOnlyContentComponent extends Component {
    static defaultProps = {
        label: 'Want to change your answers on this page?',
        content: 'Please note:  all of the fields on this page are no longer editable. You can clear all of your previous data by clicking the button below',
        actionLabel: 'Start again',
        onClick: null
    };

    static propTypes = {
        label: PropTypes.string,
        content: PropTypes.string,
        actionLabel: PropTypes.string,
        onClick: PropTypes.func
    };

    render() {
        const { label, onClick, actionLabel, content } = this.props;
        return <fieldset>
            <div className='ht-formsection'>
                <div className='ht-formsection-legend'>
                    <legend>{label}</legend>
                </div>
                <div className='ht-formsection-fields'>
                    <div className='ht-field ht-contentfield'>
                        <p className='ht-readonlycontent'>{content}</p>
                        {onClick && <button className='ht-readonlybutton' type='button' data-action={actionLabel} onClick={onClick}>{actionLabel}</button>}

                    </div>
                </div>
            </div>
        </fieldset>;
    }
}
